import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire';
import { RetailersListComponent } from './retailers-list/retailers-list.component';
import { LocationComponent } from './location/location.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { GoogleMapsModule } from '@angular/google-maps';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';
import { OfferComponent } from './offer/offer.component';
import { OffersListComponent } from './offers-list/offers-list.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatGridListModule } from '@angular/material/grid-list'
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgpImagePickerModule } from 'ngp-image-picker';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatRadioModule } from '@angular/material/radio';
import { RetailerComponent } from './retailer/retailer.component';
import { LocationFormatPipe } from './location-format.pipe';
import { RetailerLinkComponent } from './retailer-link/retailer-link.component';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import {MatChipsModule} from '@angular/material/chips'
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { WelcomeComponent } from './welcome/welcome.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { NgxMaskModule } from 'ngx-mask';
import { EditAccountComponent } from './edit-account/edit-account.component';
import { ApprovalNeededComponent } from './approval-needed/approval-needed.component';
import { AdminAccountsComponent } from './admin-accounts/admin-accounts.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    RetailersListComponent,
    LocationComponent,
    OfferComponent,
    OffersListComponent,
    RetailerComponent,
    LocationFormatPipe,
    RetailerLinkComponent,
    WelcomeComponent,
    SignUpComponent,
    EditAccountComponent,
    ApprovalNeededComponent,
    AdminAccountsComponent
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebase),
    AppRoutingModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatCardModule,
    GoogleMapsModule,
    FormsModule,
    MatSliderModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatGridListModule,
    MatSelectModule,
    NgApexchartsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaterialTimepickerModule,
    MatSlideToggleModule,
    MatRadioModule,
    NgpImagePickerModule,
    MatChipsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    NgxMaskModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
